module.exports = __webpack_public_path__ + "static/media/adult2.e2dc5d37.jpg";